import * as queryString from 'query-string';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router';
import { oldPaymentsApolloClient } from '../../../old-payments-apollo-client';
import { genSignInPath } from '../../../utils/formatter/path.formatter';
import { parseAppQueryParams } from '../../../utils/url';

export const useSignInRedirect = (loaded: boolean, isAccountAuth: boolean) => {
  const { pathname, search } = useLocation();
  const { replace } = useHistory();

  React.useEffect(() => {
    if (loaded) {
      /* handle redirect to signin page*/
      if (!isAccountAuth) {
        const appQueryParams = parseAppQueryParams();
        const searchWithPaymentPathname = queryString.stringify({
          ...appQueryParams,
          return_to_payment_pathname: pathname,
        });
        oldPaymentsApolloClient.cache.reset();
        replace(genSignInPath(`?${searchWithPaymentPathname}`));
      }
    }
  }, [isAccountAuth, loaded, pathname, replace, search]);
};
